<template>
  <div id="container-page-graficas" class="container-page-graficas">
    <div v-if="chartsImg === null" class="page-graficas--row row--left">
      <div class="row--left__chart">
        <div v-if="data !== null && data.marketevolution !== null && data.marketevolution.series.length > 0">
          <highcharts :options="data.marketevolution" />
        </div>
      </div>
      <div class="row--left__chart">
        <div v-if="data !== null && data.newvs2hevolution !== null && data.newvs2hevolution.series.length > 0">
          <highcharts :options="data.newvs2hevolution" />
        </div>
      </div>
      <div class="row--left__chart">
        <div v-if="data !== null && data.timetosaleevolution !== null && data.timetosaleevolution.series.length > 0">
          <highcharts :options="data.timetosaleevolution" />
        </div>
      </div>
      <div class="row--left__chart">
        <div v-if="data !== null && data.builtstockyears !== null && data.builtstockyears.series.length > 0">
          <highcharts :options="data.builtstockyears" />
        </div>
      </div>
    </div>
    <div v-if="chartsImg === null" class="page-graficas--row row--right">
      <!--<div v-if="data !== null && data.askingpricetop25 !== null && data.askingpricetop25.series.length > 0" class="row-chart-bench">
        <highcharts :options="data.askingpricetop25" />
      </div>-->
    </div>
    <!-- ---------- -->
    <div v-if="chartsImg !== null" class="page-graficas--img">
      <img :src="chartsImg" alt="">
    </div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import { Chart } from 'highcharts-vue'
import { getScreenshotImg } from '@/utils/chartutils'

Highcharts.setOptions({
  lang: {
    decimalPoint: ',',
    thousandsSep: '.'
  },
  chart: {
    spacingLeft: 30,
    spacingRight: 30
  }
})

HighchartsMore(Highcharts)

export default {
  name: 'PageGraficas',
  components: {
    highcharts: Chart
  },
  props: {
    data: {
      default: null
    }
  },
  data() {
    return {
      marketevolution: { series: [] },
      builtstockyears: { series: [] },
      newvs2hevolution: { series: [] },
      timetosaleevolution: { series: [] },
      askingpricetop25: { series: [] },
      chartsImg: null
    }
  },
  computed: {},
  mounted() {
    const vm = this
    setTimeout(() => {
      getScreenshotImg('container-page-graficas').then((res) => {
        vm.chartsImg = res
      })
    }, 4000)
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.container-page-graficas {
  width: 100%;
  height: 100%;
  display: grid;
  position: relative;

  grid-template-columns: 4fr 0fr;
  grid-template-rows: 1fr;
  gap: 20px;

  .row--left {
    display: flex;
    flex-wrap: wrap;

    &__chart {
      width: 50%;
      height: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      div {
        width: 100%;
        height: 100%;

        div .highcharts-container {
          padding-top: 0 !important;
        }
      }
    }
  }

  .row--right {
    width: 100%;
    height: 100%;

    &__chart {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }
}

.page-graficas--img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>

<style lang="scss">
.row--left {
  &__chart div div .highcharts-container {
    padding-top: 0 !important;
  }
}

.row-chart-bench {
  height: 698px;
  div {
    .highcharts-container {
      padding-top: 0 !important;
    }
  }
}
</style>
